import {
  CreateAicaEmailDigestSubscriptionMutation,
  CreateAicaEmailDigestSubscriptionMutationVariables,
  DeleteAicaEmailDigestSubscriptionMutation,
  DeleteAicaEmailDigestSubscriptionMutationVariables,
  GetAicaEmailDigestSubscriptionsQuery,
  GetAicaEmailDigestSubscriptionsQueryVariables,
  SendTestAicaDigestMutation,
  SendTestAicaDigestMutationVariables,
  UpdateAicaEmailDigestSubscriptionMutation,
  UpdateAicaEmailDigestSubscriptionMutationVariables,
} from 'types/graphql'

import { useMyOrgId } from 'src/layouts/AppStateContextLayout/utils'
import { QueryKey, useMutation, useQuery } from 'src/utils/queryClient'

const GetAicaEmailDigestSubscriptionsQueryDocument = gql`
  query GetAicaEmailDigestSubscriptionsQuery($input: GetAicaEmailDigestSubscriptionsInput!) {
    aicaEmailDigestSubscriptions(input: $input) {
      ...AicaEmailDigestSubscriptionFragment
    }
  }
`

const CreateAicaEmailDigestSubscriptionMutationDocument = gql`
  mutation CreateAicaEmailDigestSubscriptionMutation(
    $input: CreateAicaEmailDigestSubscriptionInput!
  ) {
    createAicaEmailDigestSubscription(input: $input) {
      ...AicaEmailDigestSubscriptionFragment
    }
  }
`

const UpdateAicaEmailDigestSubscriptionMutationDocument = gql`
  mutation UpdateAicaEmailDigestSubscriptionMutation(
    $id: Int!
    $input: UpdateAicaEmailDigestSubscriptionInput!
  ) {
    updateAicaEmailDigestSubscription(id: $id, input: $input) {
      ...AicaEmailDigestSubscriptionFragment
    }
  }
`

const DeleteAicaEmailDigestSubscriptionMutationDocument = gql`
  mutation DeleteAicaEmailDigestSubscriptionMutation(
    $input: DeleteAicaEmailDigestSubscriptionInput!
  ) {
    deleteAicaEmailDigestSubscription(input: $input) {
      ...AicaEmailDigestSubscriptionFragment
    }
  }
`

export const useGetAicaEmailDigestSubscriptionsQuery = () => {
  const organizationId = useMyOrgId()

  const { data, ...rest } = useQuery<
    GetAicaEmailDigestSubscriptionsQuery,
    GetAicaEmailDigestSubscriptionsQueryVariables
  >({
    queryKey: [QueryKey.AicaEmailDigestSubscriptions, organizationId],
    queryDocument: GetAicaEmailDigestSubscriptionsQueryDocument,
    variables: {
      input: {
        organizationId,
      },
    },
    enabled: !!organizationId,
  })

  return {
    ...rest,
    data: data?.aicaEmailDigestSubscriptions,
  }
}

export const useCreateAicaEmailDigestSubscriptionMutation = () => {
  return useMutation<
    CreateAicaEmailDigestSubscriptionMutation,
    CreateAicaEmailDigestSubscriptionMutationVariables
  >({
    mutationDocument: CreateAicaEmailDigestSubscriptionMutationDocument,
  })
}

export const useUpdateAicaEmailDigestSubscriptionMutation = () => {
  return useMutation<
    UpdateAicaEmailDigestSubscriptionMutation,
    UpdateAicaEmailDigestSubscriptionMutationVariables
  >({
    mutationDocument: UpdateAicaEmailDigestSubscriptionMutationDocument,
  })
}

export const useDeleteAicaEmailDigestSubscriptionMutation = () => {
  return useMutation<
    DeleteAicaEmailDigestSubscriptionMutation,
    DeleteAicaEmailDigestSubscriptionMutationVariables
  >({
    mutationDocument: DeleteAicaEmailDigestSubscriptionMutationDocument,
  })
}

const SendTestAicaDigestMutationDocument = gql`
  mutation SendTestAicaDigestMutation($input: SendTestAicaDigestInput!) {
    sendTestAicaDigest(input: $input)
  }
`

export const useSendTestAicaDigestMutation = () => {
  return useMutation<SendTestAicaDigestMutation, SendTestAicaDigestMutationVariables>({
    mutationDocument: SendTestAicaDigestMutationDocument,
  })
}
